import {
  ActionType as ActionTypeQuantity
} from "../product-quantity/const.js";

export const LAYOUT_CHANGE_MEDIA_QUERY = `(max-width: 1180px)`;

export const defaultProductTitleModelData = {
  isLayoutChanged: false,
  price: null,
  oldPrice: null,
  quantity: null,
  perPallet: null,
  volume: null,
  totalPerPallet: null,
  totalVolume: null,
  totalCurrentPrice: null,
  totalOldPrice: null,
  initProductPropertiesTrigger: false,
  preventReplaceableActionButtons: true
};

export const ActionType = Object.assign(
    {},
    ActionTypeQuantity,
    {
      INIT: `INIT`,
      CHANGE_LAYOUT: `CHANGE_LAYOUT`,
      RESET_LAYOUT: `RESET_LAYOUT`
    }
);

export const KeyboardKey = {
  ENTER: `Enter`
};
